var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7048 16.7651C15.6215 16.7651 17.1752 15.2113 17.1752 13.2946C17.1752 11.378 15.6215 9.82422 13.7048 9.82422C11.7881 9.82422 10.2344 11.378 10.2344 13.2946C10.2344 15.2113 11.7881 16.7651 13.7048 16.7651Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4509 2.4502L8.46628 4.61921H5.02839C3.83543 4.61921 2.85938 5.59527 2.85938 6.78822V19.8023C2.85938 20.9953 3.83543 21.9713 5.02839 21.9713H22.3805C23.5735 21.9713 24.5495 20.9953 24.5495 19.8023V6.78822C24.5495 5.59527 23.5735 4.61921 22.3805 4.61921H18.9426L16.958 2.4502H10.4509ZM13.7044 18.7178C10.7112 18.7178 8.28191 16.2885 8.28191 13.2953C8.28191 10.302 10.7112 7.87273 13.7044 7.87273C16.6977 7.87273 19.127 10.302 19.127 13.2953C19.127 16.2885 16.6977 18.7178 13.7044 18.7178Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c50f7a62.svg";
export { ForwardRef as ReactComponent };